<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <template #TEMP="{ visible, params }">
      <div class="header-title" v-if="visible">
        <h3>{{ params.row && params.row.client_name }}</h3>
        <Button
          type="warning"
          @click="exportClick"
          :disabled="disabled()"
          icon="md-arrow-down"
          style="margin-left: 10px"
        >
          {{ $t("export") }}
        </Button>
        <Button
          type="primary"
          @click="addClick(params)"
          icon="md-add"
          style="margin-left: 10px"
          v-if="$hasPermission(397)"
        >
          {{ $t("add") }}
        </Button>
      </div>
      <!-- {{visible}} -->
    </template>
  </cTable>
</template>

<script>
import {
  getHandleFee,
  getDetails,
  add,
  getConfig,
  update,
  del,
  getRules,
  getRulesDetails,
  createRules,
  updateRules,
  delRules,
  getCodMethod,
  getClientType,
  getOperator,
	saveRules
} from "@/api/finance/handleFee";

import { getCountry } from "@/api/system/country";
import { getAllClient, getCompanies } from "@/api/user/client";
import cTable from "@/base/common/index";
import { getAllService } from "@/api/user/internal";
// import Temp from "./temp";
import { getCurrency } from "@/api/finance/currency";
export default {
  name: "handleFee",
  components: {
    cTable
  },
  async mounted() {
		let fromCountry = (await getCountry({ allow_depart: 1 })).data.payload.rows;
		let toCountry = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
		let client = (await getAllClient()).data.payload.rows;
    this.header.searchs.forEach(async item => {
			if (item.key === "from_country") item.options = [{ title: "ALL", code: "*" }].concat(fromCountry);
			if (item.key === "to_country") item.options = [{ title: "ALL", code: "*" }].concat(toCountry);
			if (item.key === "client_id") item.options = [{ account: "ALL", id: "*" }].concat(client);
      if (item.key === "collection_method") {
        item.options = (await getCodMethod()).data.payload;
        this.codMethodList = item.options;
      }
      if (item.key === "account_type") {
        item.options = (await getClientType()).data.payload;
        this.clientTypeList = item.options;
      }
      if (item.key === "operator")
        item.options = (await getOperator()).data.payload;
      if (item.key === "salesman_id")
        item.options = (await getAllService()).data.payload[5];
			
    });
  },
  methods: {
    addClick({ row }) {
      this.$refs["table"].getModal("modalAdd").open(null, function() {
        Object.assign(this.$refs["form"].formData, {
          client_name: row.client_name,
          client_id: row.client_id,
          to_country: row.to_country,
          id: row.id
        });
      });
    },
    disabled() {
      let modal =
        this.$refs["table"] && this.$refs["table"].getModal("childModal");
      return !(modal && modal.selectAll.length);
    },
    exportClick() {
      let modal = this.$refs["table"].getModal("childModal");
      modal.$page.exportExc({
        data: modal.selectAll,
        fields: modal.table.fields,
        name: modal.params.row.client_name + "——" + this.$t("specialRule")
      });
    }
  },
  data() {
    return {
      clientTypeList: [],
      codMethodList: [],
      methods: {
        list: getHandleFee,
        getDetails,
        del,
        add,
        getConfig,
        getAllClient,
        getCountry,
        update,
        rulesList: getRules,
        createRules,
        getRulesDetails,
        updateRules,
        delRules,
        getClientType,
        getCodMethod,
        getOperator,
        getCompanies,getCurrency,saveRules
      },
      config: {
        height: 630
      },
      modals: {
        childModal: {
					methods:{
						ok({ row, close }) {
							this.$page.handleRequestMethods('saveRules', {id:row.id,rules:this.list},true,true).then(res => {
								this.$page.getList();
								close();
							})
						}
					},
          config: {
            modalBind: {
              width: "80%"
            }
          },
          table: {
            fields: [
              {
                name: () => this.$tz("收款方式"),
                key: "pay_type",
                minWidth: 100,
              },
							{
								name: this.$tz('类型'),
								key: 'collection_method',
								component: 'Select',
								placeholder: () => this.$tz('类型'),
								minWidth: 100,
								options: [
									{
										label:this.$tz('比例'),
										value:1
									},
									{
										label:this.$tz('每票固定金额'),
										value:2
									}
								],
								optionsFn: '',
								optionsKey: '',
								default:'',
							},
							{
								name: () => this.$t('比例'),
								key: 'fee_rate',
								placeholder: () => this.$tz('比例'),
								minWidth: 100,
								component:'InputNumber',
								default:0,
								bind:{
									style:'width:100%',
									max:100,
									min:0,
									step:0.1,
									formatter:value => `${value}%`,
									parser:value => value.replace('%', ''),
								},
							},
							{
								name: () => this.$t('固定金额'),
								key: 'every_amount',
								placeholder: () => this.$tz('固定金额'),
								minWidth: 100,
								component:'InputNumber',
								default:0,
								bind:{
									style:'width:100%',
								}
							},
							{
								name: () => this.$tz('金额,币种'),
								key: 'every_amount_currency',
								placeholder: () => this.$tz('金额,币种'),
								minWidth: 100,
								component:'Select',
								options:[],
								optionsFn:'getCurrency',
							},
            ],
            config: {
              height: 500
            }
          }
        },
        modalAdd: {
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: false
            },
            title: this.$t("add"),
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: () => true
          },
          methods: {
            ok({ row, close }) {
              let data = row;
              data.id = row.id;
              let text = row.id ? "updateRules" : "createRules";
              this.$page.handleRequestMethods(text, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page
                  .handleRequestMethods(
                    "rulesList",
                    this.$page.getModal("childModal").params.row.id
                  )
                  .then(res => {
                    this.$page.getModal("childModal").list = res.payload;
                  });

                close();
              });
            }
          },

          grid: [
            { client_name: 24 },
            { to_country: 24 },
            { collection_method: 24 },
            { every_amount: 24 },
            { every_amount_currency: 24 },
            { scope_min_cod: 24 },
            { scope_max_cod: 24 },
            { scope_currency: 24 }
          ],
          fields: [
            {
              name: () => this.$t("clientName"),
              key: "client_name",
              component: "Input",
              disabled: true
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Input",
              options: [],
              config: { label: "title", value: "code" },
              bind: {
                border: true
              },
              disabled: true,

              placeholder: () => this.$t("select") + this.$t("target_country")
            },
            {
              name: this.$t("collection") + this.$t("type"),
              key: "collection_method",
              component: "Radio",
              options: [{ label: this.$t("fixed"), value: 2 }],
              bind: {
                border: true
              },
              default: 2,
              disabled: true
            },

            {
              name: () => this.$t("fixed") + this.$t("reChAmount"),
              key: "every_amount",
              component: "InputNumber",
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name:
                this.$t("fixed") +
                this.$t("reChAmount") +
                this.$t("currency_t"),
              key: "every_amount_currency",
              component: "Select",
              options: [
                { label: "USD", value: "USD" },
                { label: "CNY", value: "CNY" }
              ],
              default: "USD",
              disabled: true
            },
            {
              name:
                this.$t("interval") + this.$t("numMin") + this.$t("reChAmount"),
              key: "scope_min_cod",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                max: 0.1,
                style: "width:100%"
              },
              default: 0
            },
            {
              name:
                this.$t("interval") + this.$t("numMax") + this.$t("reChAmount"),
              key: "scope_max_cod",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name:
                this.$t("interval") +
                this.$t("reChAmount") +
                this.$t("currency_t"),
              key: "scope_currency",
              component: "Select",
              options: [
                { label: "USD", value: "USD" },
                { label: "CNY", value: "CNY" }
              ],
              default: "USD",
              disabled: true
            }
          ]
        },
        add: {
          methods: {
            ok({ row, close }) {
              let out_time_start = 0;
              let out_time_end = 0;
              if (row.out_time_start)
                out_time_start = new Date(row.out_time_start).getTime() / 1000;
              if (row.out_time_end)
                out_time_end = new Date(row.out_time_end).getTime() / 1000;
              let data = {};
              this.$refs["form"].filterFields.forEach(
                item => (data[item.key] = row[item.key])
              );
              data.out_time_start = out_time_start;
              data.out_time_end = out_time_end;
              if (row.id) data.id = row.id;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 1000,
              draggable: true,

              maskClosable: false,
              styles: {
                top: "20px"
              }
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              account_type: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              client_id: [
                {
                  required: true,
                  type: "any",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
							from_country: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "change"
							  }
							],
              is_charge: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              collection_method: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              fee_rate: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              every_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              every_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                }
              ],
              mini_price: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              mini_price_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { account_type: 24 },
            { ownership: 12 , client_id: 12 },
            { tag: 24 },
						{from_country:12,to_country: 12 },
            { time_type: 24 },
            { out_time_start: 12 , out_time_end: 12 },
            { is_charge: 24 },
            { mini_price: 12 ,mini_price_currency: 12 },
            { remarks: 24 },
            { collection_method: 24 },
            { fee_rate: 24 },
            { every_amount: 12 ,every_amount_currency: 12 },
            { vat_rate: 24 }
          ],
          fields: [
            {
              name: this.$t("b2bClient") + this.$t("type"),
              key: "account_type",
              component: "Radio",
              options: [],
              default: 1,
              bind: {
                border: true
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getClientType")
                  ).payload;
                  this.$forceUpdate();
                },
                "on-change"({ formData, fields }) {
                  formData.ownership = "";
                  fields.forEach(async field => {
                    if (field.key === "client_id") {
                      if (formData.account_type == 1) {
                        field.options = [{
                        account: 'ALL',
                        ownership_name:'*',
                        id: "*"
                      },...(
                          await this.$page.handleRequestMethods("getAllClient")
                        ).payload.rows];
                      } else {
                        field.options = [{
                        account: 'ALL',
                        ownership_name:'*',
                        id: "*"
                      },...(
                          await this.$page.handleRequestMethods("getConfig")
                        ).payload.company.map(item => {
                          return { account: item.value, id: item.key };
                        })];
                      }
                    }
                  });
                }
              }
            },
            {
              name: this.$t("b2bClient") + this.$t("ownership"),
              key: "ownership",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("ownership"),
              options: [],
              config: {
                label: "title",
                value: "id"
              },
              show({ formData, field }) {
                if (field.options.length == 0) {
                  this.$nextTick(async () => {
                    field.options = (
                      await this.$page.handleRequestMethods("getCompanies")
                    ).payload;
                    this.$forceUpdate();
                  });
                }
                return formData.account_type == 1;
              },
              methods: {
                "on-change"({ formData, fields }) {
                  fields.forEach(async field => {
                    if (field.key === "client_id") {
                      field.options = [{
                        account: 'ALL',
                        ownership_name:'*',
                        id: "*"
                      },...(
                        await this.$page.handleRequestMethods("getAllClient", {
                          ownership: formData.ownership
                        })
                      ).payload.rows];
                    }
                  });
                }
              }
            },
            {
              name: ({ row }) => {
                return row.account_type == 1
                  ? this.$t("clientName")
                  : this.$t("company_t") + this.$t("alipay_name");
              },
              key: "client_id",
              component: "Select",
              options: [],
              config: {
                label: ({ row,formData }) => {
                  return row.account + (formData.account_type == 1?"(" + row.ownership_name + ")":'');
                },
                value: "id"
              },
              bind: {
                border: true
              },
              methods: {
                list({ formData, field }) {
                  this.$nextTick(async () => {
                    if (formData.account_type == 1) {
                      field.options = [{
                        account: 'ALL',
                        ownership_name:'*',
                        id: "*"
                      },...(
                        await this.$page.handleRequestMethods("getAllClient", {
                          ownership: formData.ownership
                        })
                      ).payload.rows];
                    } else {
                      field.options = [{
                        account: 'ALL',
                        ownership_name:'*',
                        id: "*"
                      },...(
                        await this.$page.handleRequestMethods("getConfig")
                      ).payload.company.map(item => {
                        return { account: item.value, id: item.key };
                      })];
                    }
                  });
                }
              },
              placeholder: () =>
                this.$t("clientName") +
                "/" +
                this.$t("company_t") +
                this.$t("alipay_name")
            },
            {
              name: this.$t("tag"),
              key: "tag",
              component: "Select",
              placeholder: () => this.$t("select") + "Tag",
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getConfig")
                  ).payload.tag.map(item => {
                    return { label: item, value: item };
                  });
                  this.$forceUpdate();
                },
                "on-clear"({ formData }) {
                  formData.tag = "";
                }
              }
            },
						{
						  name: () => this.$t("from_country"),
						  key: "from_country",
						  component: "Select",
						  options: [],
						  config: { label: "title", value: "code" },
						  bind: {
						    border: true
						  },
						  methods: {
						    async list({ field }) {
						      field.options = (
						        await this.$page.handleRequestMethods("getCountry", {
						          allow_depart: 1
						        })
						      ).payload.rows;
						      field.options.unshift({ title: "ALL", code: "*" });
						      this.$forceUpdate();
						    }
						  },
						  placeholder: () => this.$t("select") + this.$t("target_country")
						},
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Select",
              options: [],
              config: { label: "title", value: "code" },
              bind: {
                border: true
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry", {
                      allow_arrive: 1
                    })
                  ).payload.rows;
                  field.options.unshift({ title: "ALL", code: "*" });
                  this.$forceUpdate();
                }
              },
              placeholder: () => this.$t("select") + this.$t("target_country")
            },
            {
              name: () => this.$t("time") + this.$t("type"),
              key: "time_type",
              component: "Radio",
              options: [
                { label: this.$t("outbound_time"), value: 1 },
                { label: "POD" + this.$t("time"), value: 2 }
              ],
              default: 1,
              bind: {
                border: true
              }
            },
            {
              name: () => this.$t("start") + this.$t("time"),
              key: "out_time_start",
              component: "DatePicker",
              bind: {
                type: "datetime"
              },
              placeholder: () =>
                this.$t("select") + this.$t("start") + this.$t("time"),
              disabledDate: true
            },
            {
              name: () => this.$t("end") + this.$t("time"),
              key: "out_time_end",
              component: "DatePicker",
              bind: {
                type: "datetime"
              },
              placeholder: () =>
                this.$t("select") + this.$t("end") + this.$t("time"),
              disabledDate: true
            },
            {
              name: this.$t("whether") + this.$t("charge"),
              key: "is_charge",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: "YES" },
                { label: this.$t("NO"), value: "NO" }
              ],
              bind: {
                border: true
              }
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks")
            },
            {
              name: this.$t("lowCost") + this.$t("reChAmount"),
							placeholder: () => this.$t("lowCost") + this.$t("reChAmount"),
              key: "mini_price",
              component: "InputNumber",
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0,
              show({ formData }) {
                return formData.is_charge == "YES";
              }
            },
            {
              name: this.$t("lowCost") + this.$t("currency_t"),
							placeholder: () => this.$t("lowCost") + this.$t("currency_t"),
              key: "mini_price_currency",
              component: "Select",
              options: [],
              default: "CNY",
              show({ formData }) {
                return formData.is_charge == "YES";
              },
							config: {
								label: "title",
								value: "code",
							},
							methods: {
								list({ field }) {
									getCurrency().then((res) => {
										if (res.data.status) {
											field.options = res.data.payload.rows;
										}
									});
								},
							},
            },
            {
              name: this.$t("charge") + this.$t("mode"),
							placeholder: () =>  this.$t("charge") + this.$t("mode"),
              key: "collection_method",
              component: "Radio",
              options: [],
              bind: {
                border: true
              },
              show({ formData }) {
                return formData.is_charge == "YES";
              },
              methods: {
                async list({ field,formData }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCodMethod")
                  ).payload.filter(t=>t.value == 3?formData.id:true);
                  this.$forceUpdate();
                },
                "on-change"({ formData }) {
                  formData.fee_rate = 0;
                  formData.every_amount = 0;
                  formData.every_amount_currency = '';
                  if (formData.is_charge == "NO") {
                    formData.collection_method = "";
                  }
                }
              }
            },
            {
              name: () => this.$t("ratio"),
							placeholder: () =>  this.$t("ratio"),
              key: "fee_rate",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.001,
                style: "width:100%"
              },
              default: 0,
              show({ formData }) {
                return formData.collection_method == 1;
              }
            },
						{
						  name: () => this.$t("VATRate"),
							placeholder: () =>  this.$t("VATRate"),
						  key: "vat_rate",
						  component: "InputNumber",
						  bind: {
						    min: 0,
						    step: 0.001,
						    style: "width:100%"
						  },
						  default: 0,
							show({ formData }) {
							  return formData.is_charge == "YES";
							},
						},
            {
              name:
                this.$t("per_ticket") +
                this.$t("fixed") +
                this.$t("reChAmount"),
							placeholder: () =>  this.$t("per_ticket") +
                this.$t("fixed") +
                this.$t("reChAmount"),
              key: "every_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0,
              show({ formData }) {
                return formData.collection_method == 2;
              }
            },
            {
              name:
                this.$t("per_ticket") +
                this.$t("reChAmount") +
                this.$t("currency_t"),
							placeholder: () =>  this.$t("per_ticket") +
                this.$t("reChAmount") +
                this.$t("currency_t"),
              key: "every_amount_currency",
              component: "Select",
              options: [],
              default: '',
              show({ formData }) {
                return formData.collection_method == 2;
              },
							config: {
								label: "title",
								value: "code",
							},
							methods: {
								list({ field }) {
									getCurrency().then((res) => {
										if (res.data.status) {
											field.options = res.data.payload.rows;
										}
									});
								},
							},
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "is_charge",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("whether") + this.$t("charge");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              { label: this.$t("NO"), value: "NO" }
            ]
          },
          {
            key: "collection_method",
            component: "Select",
            placeholder() {
              return this.$t("collection") + this.$t("mode");
            },
            clearable: true,
            options: []
          },
          {
            key: "account_type",
            component: "Select",
            placeholder() {
              return this.$t("b2bClient") + this.$t("type");
            },
            clearable: true,
            options: []
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: []
          },
          {
            key: "operator",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("operate");
            },
            clearable: true,
            options: []
          },
					{
					  key: "client_id",
					  placeholder() {
					    return this.$t("select") + this.$t("clientName");
					  },
					  component: "Select",
					  options: [],
					  config: {
					    label: "account",
					    value: "id",
					  },
					},
          {
            key: 'ownership',
            placeholder() {
              return this.$tz('所属公司')
            },
            component: 'Select',
            options: [],
            optionsFn: 'getAllCompanies',
            optionsKey: '',
          },
					{
					  key: "from_country",
					  placeholder() {
					    return this.$t("select") + this.$t("from_country");
					  },
					  component: "Select",
					  options: [],
					  config: {
					    label: "title",
					    value: "code",
					  },
					},
					{
					  key: "to_country",
					  placeholder() {
					    return this.$t("select") + this.$t("allow_arrive");
					  },
					  component: "Select",
					  options: [],
					  config: {
					    label: "title",
					    value: "code",
					  },
					},
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 391
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: this.$t("b2bClient") + this.$t("type"),
          key: "account_type",
          methods: {
            render: ({ value }) => {
              return (
                this.clientTypeList.length > 0 &&
                this.clientTypeList.find(item => item.value == value).label
              );
            }
          },
          width: 90
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          width: 90
        },
        {
          name: () => this.$tz("所属公司"),
          key: "ownership_name",
          width: 110
        },
        {
          name: () => this.$t("salesman"),
          key: "salesman_account",
          width: 90
        },
        {
          name: "tag",
          key: "tag",
          width: 90
        },
				{
				  name: () => this.$t("allow_depart"),
				  key: "from_country",
				  width: 90
				},
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          width: 90
        },
        {
          name: this.$t("whether") + this.$t("charge"),
          key: "is_charge",

          width: 80,
          methods: {
            render({ row }) {
              return row.is_charge == "YES" ? this.$t("YES") : this.$t("NO");
            }
          }
        },
        {
          name: this.$t("charge") + this.$t("mode"),
          key: "collection_method",

          component: "Button",
          width: 90,
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            render: ({ value }) => {
							let r = this.codMethodList.find(item => item.value == value) || {}
              return (
                this.codMethodList.length > 0 &&
                value > 0 &&
                (r.label || '-')
              );
            },
            click({ row }) {
              this.$page.getModal("childModal").open({ row,id:row.id }, function() {
                this.setTitle(this.$tz("收款方式"));
                this.$page
                  .handleRequestMethods("rulesList", row.id)
                  .then(res => {
                    this.list = res.payload;
                  });
              });
            }
          },
          disabled({ row }) {
            return !this.$hasPermission(395) || row.collection_method != 4;
          }
        },
        {
          name: () => this.$t("ratio"),
          key: "fee_rate",
          width: 90
        },
				{
				  name: () => this.$t("VATRate"),
				  key: "vat_rate",
				  width: 90
				},
        {
          name: () => this.$t("fixed") + this.$t("reChAmount"),
          key: "every_amount",
          width: 90
        },
        {
          name: () => this.$t("currency_t"),
          key: "every_amount_currency",
          width: 90
        },
        {
          name: this.$t("lowCost") + this.$t("reChAmount"),
          key: "mini_price",
          width: 90
        },
        {
          name: this.$t("lowCost") + this.$t("currency_t"),
          key: "mini_price_currency",
          width: 90
        },
        {
          name: () => this.$t("time") + this.$t("type"),
          key: "time_type",
          width: 90,
          methods: {
            render({ value }) {
              return value == 1
                ? this.$t("outbound_time")
                : "POD" + this.$t("time");
            }
          }
        },
        {
          name: () => this.$t("start") + this.$t("time"),
          key: "out_time_start",
          width: 150,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("end") + this.$t("time"),
          key: "out_time_end",
          width: 150,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          width: 90
        },
        {
          name: this.$t("operation") + this.$t("time"),
          key: "update_time",
          width: 150
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 392
            },
						{
						  name: () => this.$t("copy"),
						  type: "copy",
						  fnName: "copy",
						  bind: {
						    type: "primary"
						  },
						  id: 391
						},
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 393
              // bind: {
              //   type: "error"
              // }
            }
          ],
          methods: {
						copy({ row }) {
						  this.handleRequestMethods("getDetails", row.id).then(res => {
								this.getModal("add").setTitle(this.$t("add"));
								this.getModal("add").type = "add";
						    let data = res.payload;
								delete data.id
						    data.out_time_start =
						      res.payload.out_time_start > 0
						        ? this.format.timeFormat(res.payload.out_time_start * 1000)
						        : "";
						    data.out_time_end =
						      res.payload.out_time_end > 0
						        ? this.format.timeFormat(res.payload.out_time_end * 1000)
						        : "";
						    this.getModal("add").open(data, function() {
						      this.config.modalBind.maskClosable = false;
						    });
						  });
						},
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                let data = res.payload;
                data.out_time_start =
                  res.payload.out_time_start > 0
                    ? this.format.timeFormat(res.payload.out_time_start * 1000)
                    : "";
                data.out_time_end =
                  res.payload.out_time_end > 0
                    ? this.format.timeFormat(res.payload.out_time_end * 1000)
                    : "";
                this.getModal("add").open(data, function() {
                  this.config.modalBind.maskClosable = false;
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style>
.header-title {
  display: flex;
  height: 40px;
  align-items: center;
}
</style>
